<template>
    <!-- Start Main Content -->
    <div v-show="!isBarcodePrint" class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Employee Attendance</h2>
             <!-- <button type="reset" @click="printBarcode" class="btn b-light btn-danger-light btn-sm">Barcode</button> -->
        </div>





        <div class="card p-4 mb-4">
            <div class="flex items-center space-x-4">
                <div>
            <label for="entryDate" class="block text-sm font-medium text-gray-700">Entry Date:</label>
            <input type="date" id="entryDate" v-model="employee.filter_date"  class="p-2 border border-gray-300 rounded" />
            </div>     
            
            
          
            
            <div class="ml-3"> 
                <label for="parentId" class="block text-sm font-medium text-gray-700">Select Parent ID:</label>
                <select v-model="employee.filter_parent"  class="p-2 border border-gray-300 rounded">
                    <option value="" disabled>Select Parent</option>
                    <option v-for="parent in parentList" :key="parent.id" :value="parent.id">{{ parent.name }}</option>
                </select>
            </div>
            <!-- <button class="btn btn-primary bg-info"  @click="FilterData(item)"  >
                <i class="ri-edit-2-line text-inherit text-[13px]"></i> Show Employees
            </button> -->
          
            <div class="ml-3">
            <div class="flex justify-end mt-7">
                <button @click="FilterData(item)" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Filter</button>
            </div> 
           </div>

            </div>
        </div>


     





        <div class="grid grid-cols-12">
            <!-- INITIALIZE CSS CLASS -->
            <div class="hidden">
                <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
            </div>
            <!-- INITIALIZE CSS CLASS -->
            <div class="tablejs sr-only size-0"></div>
            <!-- BASIC DATA TABLE -->
            <div class="col-span-full">
                <div class="card p-0">
                    <div class="p-6 space-y-4">
                        <table id="basicDataTable" class="datatable">
                            <thead>
                                <tr>
                                    <th class="bg-[#B2E8D9]">Sr.No</th>
                                    <th class="bg-[#B2E8D9]">Employee Name</th>
                                    <th class="bg-[#B2E8D9]">Half Day</th>
                                    <th class="bg-[#B2E8D9]">Presenty</th>
                                    <th class="bg-[#B2E8D9]">Performance</th>
                                    <th class="bg-[#B2E8D9]">Remark</th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr v-for="(item ,index)  in employeeList" :key="item.id">
                                    <!-- <td><input type="checkbox" @click="barcode_select(item)"/></td> -->
                                    <td>{{ index + 1 }}</td> <!-- Serial number -->
                                    <!-- <td v-if="false">{{ item.branchid }}</td>
                                    <td v-if="false">{{ item.plotid }}</td> -->
                                    <td>{{ item.name }}</td>
                            

                                    <td>
                                        <input 
                                            type="checkbox" 
                                            v-model="item.halfday" 
                                            :true-value="1" 
                                            :false-value="0"
                                        />
                                    </td>
                                    
                                 
                                    <!-- Checkbox for Presenty -->
                                    <td>
                                        <input 
                                            type="checkbox" 
                                            :checked="item.presenty === 1" 
                                            @change="updatePresenty(item, $event.target.checked)" 
                                        />
                                    </td>
                                    <!-- Dropdown for Performance -->
                                    <td>
                                        <select v-model="item.performance" class="form-input">
                                            <option value="3">Best</option>
                                            <option value="2">Good</option>
                                            <option value="1">Average</option>
                                        </select>
                                    </td>
                                    <td>
                                        <input type="text" v-model="item.remark" class="form-input" />
                                    </td>
                                </tr> 
                                
                            </tbody>
                        </table>

          <!------------------------------------start-------------------------------------------->

          <div class="flex space-x-3"> 
            <!-- Branch Name -->
            <div class="flex-1">
                <label for="branchId" class="block text-sm font-medium text-gray-700">Branch Name:</label>
                <select v-model="employee.filter_branch" @change="fillPlots()" class="p-2 border border-gray-300 rounded w-full">
                    <option value="" disabled>Select Branch</option>
                    <option v-for="branch in branchList" :key="branch.branchid" :value="branch.id">{{ branch.name }}</option>
                </select>
            </div>
        
            <!-- Plot Name -->
            <div class="flex-1 ml-3">
                <label for="plotId" class="block text-sm font-medium text-gray-700">Plot Name:</label>
                <select v-model="employee.filter_plot" class="p-2 border border-gray-300 rounded w-full">
                    <option value="" disabled>Select Plot</option>
                    <option v-for="plot in plotList" :key="plot.id" :value="plot.id">{{ plot.name }}</option>
                </select>
            </div>
        
            <!-- Save Button -->
            <div class="flex-1 ml-3">
                <button @click="save" id="saveBtn" class="btn b-solid btn-primary-solid px-5 cursor-pointer mt-6 w-full">
                    Save Attendance
                </button>
            </div>
        </div>
        
                        
        <!------------------ end-------------------------------------------------------------------------- -->

                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
            <!-- BORDERED SELECTION DELETION DATA TABLE -->
            
        </div>
    </div>
    <!-- End Main Content -->
       <!-- Start Delete Modal -->
       
    <BarcodeComp :GetproductsList="productsList" v-if='isBarcodePrint' @hideprintBarcode="printBarcode"/> 
       
    <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5 text-center">
                    <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                    <div class="mt-5 text-center">
                        <h5 class="mb-1">Are you sure?</h5>
                        <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                        <div class="flex justify-center gap-2 mt-6">
                            <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                            <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Delete Modal -->
    
    
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';
import BarcodeComp from '@/components/BarcodeComp.vue'

export default {
name: 'AddProduct',
components: {
 BarcodeComp
} ,
mounted(){
 this.getBasics();
},
data() {
 return {
     isBarcodePrint:false,
     isAdd:0,
     isEdit:0,
     isDelete: 0,
     deleteId: 0,
     productsList:[],
     employeeList:[],
     branchList:[],
     plotList:[],
     parentList: [], // Store parent options
     all_plotList:[],
     

     
     entryDate: '',
     selectedParentId:'', // Property for the selected date
     datatable:null,
    //  product:{name:'',cat:'0',barcode:'',hsn:'',descr:'',gst:'5',unit:'',mrp:'0',prate:'0',salerate:'0',set_rate:'0',set_qty:'0',},
   // product:{productid:'',manufacturingdate:'',expirydate:'',batchno:'',openingstock:'',quantity:''},

//    products:{name:'',content:'',description:'',purchaserate:''},
//      employees: {empname:'',emprole:'0',isMainAdmin:0},

   employee:{
    filter_date: new Date().toISOString().split('T')[0],// Sets today's date as default
        filter_parent:0
   },
   parent:{

   },


 }
 }, 
methods:{
    printBarcode(){
      this.isBarcodePrint =!this.isBarcodePrint;
    },
      fillPlots() {
          var selected_branchid=event.target.value;
         
            this.plotList = this.all_plotList.filter(item => {
               
                return item.branchid === selected_branchid; // Ensure entryDate is a property of item 
               
            });

    },
    
    filterByDate() {
        // Directly filter employeeList based on entryDate
        this.employeeList = this.employeeList.filter(item => {
        return item.entryDate === this.entryDate; // Ensure entryDate is a property of item

        });
    },

    filterByemployee() {
        this.employeeList = this.employeeList.filter(item => {
           
           // return item.entryDate === this.entryDate; // Ensure entryDate is a property of item 
           
        });

    },

    updatePresenty(item, isChecked) {
        item.presenty = isChecked ? 1 : 0; // Set presenty to 1 if checked, 0 if unchecked
    },
    updatehalfdate(item, isChecked) {
        item.halfday = isChecked ? 1 : 0; // Set presenty to 1 if checked, 0 if unchecked
    },
    barcode_select(item){
        try {
            if(item.checked)
                item.checked=0;
            else
                item.checked=1;
            
        } catch (e) {
            item.checked=1;
        }
    },
    
 closeModal(){
     
    $("#editModal").addClass('hidden');
            $("#deleteModal").addClass('hidden');
        this.isAdd=0;
        this.isEdit=0;
        this.isDelete=0;
        this.deleteId=0;
 },
 addModal(){
     this.cat={name:'',status:'Active'};
     if(!this.isAdd)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isAdd=!this.isAdd;
 },

 editModal(item){
     if(item){
         let copy = JSON.parse(JSON.stringify(item));
         this.cat=copy;
     }
     if(!this.isEdit)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isEdit=!this.isEdit;
 },


 FilterData(item) {
                var self = this; 
                axios.post('getemployeeattendance', this.employee)
                    .then(response => {
                         // self.employeeList=response.data.employees;
                         self.branchList=response.data.branch;
                         self.plotList=response.data.plot;
                         self.all_plotList=self.plotList;
                         
                         self.employeeList = response.data.employees.map(emp => ({
                            ...emp,
                            presenty: parseInt(emp.presenty), // Convert 'presenty' to integer
                            branchid: emp.branchid || self.employee.filter_branch, // Set branch ID, default to filtered branch
                            plotid: emp.plotid || self.employee.filter_plot // Set plot ID, default to filtered plot
                        }));

                       
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
            },








 
 deleteModal(id){
    this.deleteId=id;
     if(!this.isDelete)
         $("#deleteModal").removeClass('hidden');
     else
         $("#deleteModal").addClass('hidden');
     this.isDelete=!this.isDelete;
 },
 async getBasics() {
       var self=this;
         axios.post('getBasicOfAttendance').then(function (response) {
                 
                 self.parentList=response.data.employees; 

                }).then(()=>{ 
                     self.datatable= $(".datatable").DataTable({
                            "paging": false,
                            "ordering": true,  
                            "autoWidth": false,
                            "info": false,
                            "language": {
                             "emptyTable": "",  // Remove the "No data available in table" message
                             "zeroRecords": ""
                                }
                              });
              
                    });;
  }, 







        view_barcode(id) {
            var self = this;
            window.open(window.location.origin+'/Barcode?q='+id,'_blank');
        },
            delete_category() {
                var self = this; 
                axios.post('deleteProduct', {deleteId:this.deleteId})
                    .then(response => {
                        self.productsList=response.data.products;
                        self.employees=response.data.userDetails; 
                         self.closeModal(); 
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
            },


            async save() {
            try {
                const attendanceData = this.employeeList.map(item => ({
                    id: item.id,
                    branchid: this.employee.filter_branch, // Use the selected branch ID from the employee object
                    plotid: this.employee.filter_plot,      // Ensure the correct plot ID is sent
                    presenty: item.presenty,
                    halfday: item.halfday,
                    performance: item.performance,
                    remark: item.remark,
                    entryDate: this.employee.filter_date 
                }));

                const response = await axios.post('saveAttendance', { attendance: attendanceData });

                if (response.data.success) {
                    this.$swal("Attendance saved successfully!");
                    window.location.href = 'http://157.173.221.162:8082/attendancereport';
                } else {
                    this.$swal("Failed to save attendance: " + response.data.message);
                }
            } catch (error) {
                console.error('Error while saving attendance:', error);
                this.$swal("An error occurred while saving attendance.");
            }
        },

            
}
}
</script>
